import { useState, useEffect } from 'react'
import { Options, OptionsValue } from '../../control/materialUI/SplitBottonControl'
import axios from 'axios'
import ConfigAPI from '../../constant/ConfigAPI'
import useMapStore from '../../stores/useMapStore'
import useFormReportStore from '../../stores/useFormReportStore'
import useLoadingStore from '../../stores/useLoadingStore'
import { useSelector } from 'react-redux'
import { RootStateType } from '../../redux/reducer/rootReducer'
import { useHistory } from 'react-router-dom'

const options: Options[] = [
    {
        value: 'pdf',
        label: 'ดาวน์โหลดรายงาน (PDF)',
    },
    {
        value: 'excel',
        label: 'ดาวน์โหลดรายงาน (Excel)',
    },
]

const dataSort = [
    {
        value: 'asc',
        label: 'เก่าไปใหม่',
    },
    {
        value: 'desc',
        label: 'ใหม่ไปเก่า',
    },
]

const useReportSurvey = () => {
    const [openDrawer, setOpenDrawer] = useState(true)
    const [isIos, setIsIos] = useState<boolean>(false)
    const [year, setYear] = useState<number>(new Date().getFullYear() + 543)
    const [month, setMonth] = useState<number>(new Date().getMonth() + 1)
    const [dataReport, setDataReport] = useState<Array<ReportItemDataType>>([])
    const [dataYear, setDataYear] = useState<Array<DropdownDataType>>([{ label: year.toString(), value: year }])
    const [dataMonth, setDataMonth] = useState<Array<DropdownDataType>>([{ label: month.toString(), value: month }])
    const [sort, setSort] = useState<string>('asc')
    const [openDialogError, setOpenDialogError] = useState<boolean>(false)

    const mapStore = useMapStore()
    const loadingStore = useLoadingStore()
    const formReportStore = useFormReportStore()
    const { isLoggedIn } = useSelector(({ profile }: RootStateType) => profile)
    const history = useHistory()

    useEffect(() => {
        const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent)
        setIsIos(isIos)
    }, [])

    const handleChangeYear = (evt: DropdownChangeEvent) => {
        setYear(evt as number)
        getReportData(evt as number, month)
    }

    const handleChangeMonth = (evt: DropdownChangeEvent) => {
        setMonth(evt as number)
        getReportData(year, evt as number)
    }

    const handleOpenDrawerMain = () => {
        mapStore.clearReportDataResult()
        setOpenDrawer(false)
    }

    const handleClickLocation = async (item: ReportItemDataType) => {
        try {
            loadingStore.setLoading(true)
            const data = await formReportStore.getSurveyDetail(item.dataId as number)
            if (data) {
                formReportStore.setSurveyDetail(data)
                if (item.location) {
                    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)
                    if (!isMobileDevice) {
                        mapStore.zoomLocationByLatLon(item.location, item.dataId, 12)
                    }
                }
                formReportStore.setIsOpenSurveyDetail(true)
            } else {
                formReportStore.setSurveyDetail(null)
                formReportStore.setIsOpenSurveyDetail(false)
            }
        } catch {
        } finally {
            loadingStore.setLoading(false)
        }
    }

    const getReportData = async (searchYear: number, searchMonth: number) => {
        try {
            loadingStore.setLoading(true)
            let url = `${process.env.REACT_APP_API}/api/report/survey?year=${searchYear.toString()}`
            if (searchMonth !== 0) {
                url = `${
                    process.env.REACT_APP_API
                }/api/report/survey?year=${searchYear.toString()}&month=${searchMonth.toString()}`
            }
            const result = await axios.get(url, ConfigAPI)
            let reportData: Array<ReportItemDataType> = []
            if (result.data) {
                reportData = result.data.map((item: ReportSurveyResponseType) => {
                    let retItem: ReportItemDataType = {
                        dataId: item.surveyId,
                        name: item.administrative,
                        no: item.no,
                        location: item.receivingPoint,
                        signalState: item.signalState,
                        createDate: item.createDate,
                    }
                    return retItem
                }) as Array<ReportItemDataType>

                reportData = reportData.slice().sort((a, b) => b.no - a.no)
            }
            setDataReport(reportData)
            mapStore.drawReportDataResult(reportData, 'survey')
        } catch {
            formReportStore.setSurveyDetail(null)
            formReportStore.setIsOpenSurveyDetail(false)
            setDataReport([])
            mapStore.drawReportDataResult([], 'survey')
        } finally {
            loadingStore.setLoading(false)
        }
    }

    const onClickOption = async (selectValue: OptionsValue) => {
        loadingStore.setLoading(true)
        let url = `${process.env.REACT_APP_API_REPORT}/survey?year=${year}&createBy=${'TEST'}&fileType=${selectValue}`
        try {
            if (month !== 0) {
                url = `${
                    process.env.REACT_APP_API_REPORT
                }/survey?year=${year}&month=${month}&createBy=${'TEST'}&fileType=${selectValue}`
            }
            const result = await axios.get(url, ConfigAPI)
            if (result.data) {
                globalThis.open(result.data.urlPath, '_blank')
            }
        } catch (ex) {
            console.log(ex)
            setOpenDialogError(true)
        } finally {
            loadingStore.setLoading(false)
        }
    }

    const onMenuItemClick = (selectValue: OptionsValue) => {
        onClickOption(selectValue)
    }

    const handleSortData = (evt: DropdownChangeEvent) => {
        setSort(evt as string)
    }

    const getDataSort = () => {
        if (sort === 'asc') {
            return dataReport.slice().sort((a, b) => a.no - b.no)
        } else {
            return dataReport.slice().sort((a, b) => b.no - a.no)
        }
    }

    const handleCloseErrorDialog = () => {
        setOpenDialogError(false)
    }

    useEffect(() => {
        let localRefId = globalThis.sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)

        if (!localRefId) {
            localRefId = globalThis.localStorage.getItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
        }

        if (localRefId) {
            if (isLoggedIn) {
                callServiceLookup()
            }
        } else {
            globalThis.sessionStorage.clear()
            globalThis.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
            history.push('/')
        }
    }, [isLoggedIn])

    useEffect(() => {
        return () => {
            //When Unmount Component
            formReportStore.setSurveyDetail(null)
            formReportStore.setIsOpenSurveyDetail(false)
            formReportStore.setIsDisabledMapTool(false)
            mapStore.clearReportDataResult()
        }
    }, [])

    const callServiceLookup = async () => {
        try {
            formReportStore.setIsDisabledMapTool(true)
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/report/survey/lookup`
            const result = await axios.get(url, ConfigAPI)
            if (result.data) {
                setDataYear(() => {
                    return result.data.years.map((year: string) => {
                        return {
                            label: year,
                            value: Number.parseInt(year),
                        }
                    })
                })

                setDataMonth(() => {
                    return result.data.months.map((month: ResponseLookupType) => {
                        return {
                            label: month.name,
                            value: month.code ? month.code : 0,
                        }
                    })
                })

                await getReportData(year, month)
            }
        } catch (error) {
            //@ts-ignore
            const errMsg: string = error?.toString()
            if (errMsg) {
                if (errMsg.includes('401')) {
                    //reLoginForTokenExpired()
                    //callServiceReLogin('/report-survey')
                }
            }
            return { error }
        } finally {
            loadingStore.setLoading(false)
        }
    }

    return {
        drawer: {
            openDrawer,
            openDrawerDetail: formReportStore.isOpenSurveyDetail,
            setOpenDrawer,
            setOpenDrawerDetail: formReportStore.setIsOpenSurveyDetail,
        },
        dataReport,
        dataReportDetail: formReportStore.surveyDetail,
        dataYear,
        dataMonth,
        year,
        month,
        onChangeYear: handleChangeYear,
        onChangeMonth: handleChangeMonth,
        handleClickLocation,
        handleOpenDrawerMain,
        options: {
            options,
            onClickOption,
            onMenuItemClick,
        },
        sort,
        dataSort,
        handleSortData,
        getDataSort,
        isIos,
        openDialogError,
        handleCloseErrorDialog,
    }
}

export default useReportSurvey
